import React from 'react';
import './disclaimerStatic.scss';
import { useStyles } from 'tss-react/mui';

export type DisclaimerStaticProps = {
	title?: string,
	content: string,
	classes?: {
		root?: string;
		title?: string;
		content?: string;
	}
};

const DisclaimerStatic: React.FC<DisclaimerStaticProps> = ({ content, title, classes: classOverrides }) => {
	const { cx } = useStyles();
	return (
		<div className={cx('skoda-disclaimer static', classOverrides?.root)}>
			<div className={cx('title', classOverrides?.title)}>{title}</div>
			<p dangerouslySetInnerHTML={{ __html: content }} className={cx('content', classOverrides?.content)} />
		</div>
	);
};

export default DisclaimerStatic;
